import { SingleInputConnectIntegrationFormDrawerContent } from '@modules/integrationsV2/components/AddIntegrationFormDrawerContent/SingleInputConnectIntegrationFormDrawerContent';
import { GetAddIntegrationFormDrawerContentProps } from '@modules/integrationsV2/utils/getAddIntegrationFormDrawerContent';
import { useState } from 'react';

export const FreshchatFormDrawerContent = ({
  integrationType,
  integrationChannel,
  onDrawerClose,
}: GetAddIntegrationFormDrawerContentProps) => {
  const [accessToken, setAccessToken] = useState('');

  return (
    <SingleInputConnectIntegrationFormDrawerContent
      inputFieldData={accessToken}
      setInputFieldData={setAccessToken}
      integrationChannel={integrationChannel}
      integrationType={integrationType}
      integrationData={{
        freshchat: {
          accessToken: accessToken,
        },
      }}
      textFieldProps={{
        label: 'Access Token',
        placeholder: 'Enter Access Token',
      }}
      onDrawerClose={onDrawerClose}
    />
  );
};
